import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Angulartics2Module } from 'angulartics2';
import { ItemThumbnailComponent } from './components/item-thumbnail/item-thumbnail.component';
import { SharedModule } from '../shared.module';

@NgModule({
    imports: [
        CommonModule,
        Angulartics2Module,
        SharedModule
     ],
    declarations: [
        ItemThumbnailComponent,
    ],
    exports: [
        ItemThumbnailComponent
    ]
})
export class ItemThumbnailModule {}